import { sortBy } from 'lodash';
import { z } from 'zod';
import inputs from './projects.form-schema';

export const projectSchema = z.object({
  id: z.string().optional(),
  created_by: z.string().optional(),
  description: z.string().optional().nullable().default(''),
  name: z.string().default(''),
  customer: z.string().optional().nullable(),
  external_job_id: z.string().optional().nullable(),
  project_manager_id: z.coerce.string().optional(),
  start_date: z.string().optional().nullable(),
  end_date: z.string().optional().nullable(),
  record_count: z.coerce.number().optional(),
  status: z.string().optional(),
  member_ids: z.array(z.string()).default([]),
  group_ids: z.array(z.string()).default([]),
});
export type Project = z.infer<typeof projectSchema>;

export function getProjectID() {
  const splitPath = window.location.pathname.split('/');

  switch (splitPath.length) {
    case 3:
      return undefined;
    case 4:
      return splitPath[2];
    default:
      throw Error('undefined path');
  }
}

function membersToLabelValuePairArray(objectArr: Record<any, any>) {
  if (!objectArr) {
    return [];
  }
  return objectArr.map((obj) => ({
    label: `${obj.user} (${obj.role_name})`,
    value: obj.id,
  }));
}

export const newProjectSchema = (members) => inputs.map((input) => {
  if (input.key === 'project_manager_id') {
    const loadedMembers = membersToLabelValuePairArray(members);
    return { ...input, options: sortBy(loadedMembers, 'label') };
  }

  if (input.key === 'status') {
    return { ...input, value: 'active' };
  }

  return input;
});

export const editProjectSchema = (members, project) => inputs.map((input) => {
  let editInput = { ...input };

  if (input.key === 'project_manager_id') {
    const loadedMembers = membersToLabelValuePairArray(members);
    editInput = { ...editInput, options: sortBy(loadedMembers, 'label') };
  }

  return {
    ...editInput,
    value: project[input.key] ?? '',
  };
});
